(() => {
	angular.module('main').factory('routeResolver', routeResolver);

	routeResolver.$inject = [
		'$q',
		'$rootScope',
		'$route',
		'$location',
		'accountService',
		'subscriptionDataService',
		'brandsDataService'
	];

	function routeResolver(
		$q,
		$rootScope,
		$route,
		$location,
		accountService,
		subscriptionDataService,
		brandsDataService
	) {
		return {
			resolve
		};

		function resolve() {
			const route = $route.current;
			const deferred = $q.defer();
			const isClientPortal =
				route.templateUrl && route.templateUrl.includes('client/');

			checkAuth(route).then(() => {
				changeNavbar(route);
				changeBackground();
				handleFacebookPixel(route, isClientPortal);
				if (
					!route.requireLogin &&
					accountService.isUserAuthenticated() &&
					!isClientPortal
				) {
					$location.path('/');
					deferred.reject();
				}

				if (route.adminPage && !accountService.isAdmin()) {
					deferred.reject();
				}

				deferred.resolve(true);
			});

			return deferred.promise;
		}

		function checkAuth(route) {
			const deferred = $q.defer();
			if (!accountService.isUserAuthenticated() && route.requireLogin) {
				subscriptionDataService
					.fetchSubscriptionStatus()
					.subscribe(subscription => {
						if (subscription.currentPlan) {
							brandsDataService.getBrandsData();
							accountService.getUserWeb().subscribe(
								data => {
									if (data && data.enabled) {
										subscriptionDataService.setSubscriptionData(subscription);

										$rootScope.removeBg = route.hideHeader
											? 'true'
											: 'white-background';

										deferred.resolve(true);
									}
								},
								err => deferred.reject(err)
							);
						} else {
							$location.path('/login');
							subscriptionDataService.setChoosePlanOpenModalStatus({
								state: true,
								payload: null
							});
						}
					});
			} else {
				deferred.resolve(true);
			}

			return deferred.promise;
		}

		function changeBackground() {
			const publicPaths = ['/login', '/signup', '/forgot'];

			if (publicPaths.includes($location.path())) {
				$rootScope.removeBg = false;
			}
		}

		function handleFacebookPixel(route, isClientPortal) {
			if (
				accountService.isUserAuthenticated() ||
				(route.templateUrl && isClientPortal)
			) {
				const FBPicel1 = document.getElementById('FBPicel');

				if (FBPicel1) {
					const FBPicel2 = document.getElementById('FBPicelImg');
					FBPicel1.remove();
					FBPicel2.remove();
				}
			}
		}

		function changeNavbar(route) {
			if (route.role === 'client') {
				$rootScope.showLogo = false;
				accountService.emitShowHeader(false);
				accountService.setNavigationSettings('clientUser', 'anonymousUser');
			} else if (route.adminPage) {
				$rootScope.showLogo = true;
				accountService.emitShowHeader(true);
				accountService.setNavigationSettings('adminUser');
			} else if (route.role === 'user') {
				$rootScope.showLogo = true;
				accountService.emitShowHeader(true);
				accountService.setNavigationSettings('authenticatedUser');
			} else if (route.role === 'company') {
				$rootScope.showLogo = false;
				accountService.emitShowHeader(false);
				accountService.setNavigationSettings(
					'companyUser',
					'authenticatedUser'
				);
			}
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/services/routeResolverService.js